import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './styles.module.scss';
import { miniDisclaimer } from 'constants/values';

const Arrow = ({ arrowStyle, onClick }) => (
  <button className={arrowStyle} onClick={onClick} />
);

let bmwSettings = {
  dots: true,
  arrows: true,
  nextArrow: <Arrow arrowStyle={styles.bmwRightArrow} />,
  prevArrow: <Arrow arrowStyle={styles.bmwLeftArrow} />,
};

let miniSettings = {
  dots: true,
  arrows: true,
  nextArrow: <Arrow arrowStyle={styles.miniRightArrow} />,
  prevArrow: <Arrow arrowStyle={styles.miniLeftArrow} />,
};

const TemplateDetailSlider = ({ images, mini, addDisclaimer }) => {
  let settings = mini ? miniSettings : bmwSettings;
  return (
    <div className={styles.sliderContainer}>
      {addDisclaimer && (
        <div className={styles.disclaimer}>{miniDisclaimer}</div>
      )}
      <Slider {...settings}>
        {images &&
          images.map((image, index) => (
            <div key={index}>
              <img className={styles.templateImage} src={image} alt="" />
            </div>
          ))}
      </Slider>
    </div>
  );
};

export default TemplateDetailSlider;
